import { NgClass } from '@angular/common';
import {
	AfterViewInit,
	ChangeDetectionStrategy,
	Component,
	ElementRef,
	input,
	signal,
	viewChild,
} from '@angular/core';
import { ArrowRightSvgComponent, ArrowLeftSvgComponent } from '@uc/shared/svg';

@Component({
	selector: 'uc-subjects-carousel',
	templateUrl: './subjects-carousel.component.html',
	changeDetection: ChangeDetectionStrategy.OnPush,
	imports: [ArrowLeftSvgComponent, ArrowRightSvgComponent, NgClass],
})
export class SubjectsCarouselComponent implements AfterViewInit {
	customStyles = input('pt-4 border-y');
	content = viewChild.required<ElementRef>('content');
	container = viewChild.required<ElementRef>('container');

	scrollWidth = 250;
	scrolledLeft = 0;
	scrollDelayTime = 270;
	displayRightButton = signal(false);
	displayLeftButton = signal(false);

	ngAfterViewInit(): void {
		this.updateButtonVisibility();
	}

	updateButtonVisibility() {
		if (!this.content() || !this.container()) return;

		const containerWidth = this.container().nativeElement.offsetWidth;
		const contentWidth = this.content().nativeElement.scrollWidth;

		const leftScroll = Math.ceil(this.scrolledLeft);
		this.displayRightButton.set(containerWidth + leftScroll < contentWidth);
		this.displayLeftButton.set(this.scrolledLeft > 0);
	}

	onClick(direction: 'left' | 'right') {
		if (direction === 'right') {
			this.content().nativeElement.scrollLeft += this.scrollWidth;
		} else {
			this.content().nativeElement.scrollLeft -= this.scrollWidth;
		}
		// setTimeout is used to wait for the scroll to finish
		setTimeout(() => {
			const scrollLeft = this.content().nativeElement.scrollLeft;
			this.scrolledLeft = scrollLeft;
			this.updateButtonVisibility();
		}, this.scrollDelayTime);
	}

	onScroll(event: Event) {
		const element = event.target as HTMLElement;
		this.scrolledLeft = element.scrollLeft;
		this.updateButtonVisibility();
	}
}
